/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PeriodUnit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function PeriodUnit({
  children,
  viewPath = "/DesignSystem/ReportsKpiFilters/PeriodUnit",
  onChange
  
}) {
let tabSelectedFiltersPeriodUnitsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_units',
})
let tabSelectedFiltersPeriodUnitIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_unit_id',
})
let tabSelectedFiltersPeriodUnitIdChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.filters.period_unit_id',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="tab.selected.filters.period_units"
 from={tabSelectedFiltersPeriodUnitsValueData}
 data="tab.selected.filters.period_unit_id"
 onChange={tabSelectedFiltersPeriodUnitIdChangeData}
 value={tabSelectedFiltersPeriodUnitIdValueData}
 maxWidth={100}
 flexGrow={0}
 marginLeft={dtSpaceXxs}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Unit"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}